import { useAuth } from '@restworld/feature-authentication';
import { LinkBase, Paragraph, Title } from '@restworld/ui-ds';
import { useTranslation } from 'next-i18next';
import tw from 'twin.macro';
export const Header = () => {
  const { t } = useTranslation('user-settings');
  const header = t('account_tab_header');
  const isLeadUserType = useAuth().user?.type === 'lead';
  const descriptionText = isLeadUserType
    ? `${t('account_tab_description_text').split('.')[0]}.`
    : t('account_tab_description_text');
  const link = !isLeadUserType && (
    <LinkBase link="/profilo" newTab={false} twStyle={tw`text-primary-800 underline`}>
      {t('account_tab_view_cv_text')}
    </LinkBase>
  );
  return (
    <FlexCol>
      <TitleWrapper>
        <Title standardVariant="h1" textColor="black" fontWeight="semibold" desktopOnly={true}>
          {header}
        </Title>
        <Title standardVariant="h5" textColor="black" fontWeight="semibold" mobileOnly={true}>
          {header}
        </Title>
      </TitleWrapper>
      <div tw="lg:w-[42.438rem] w-full">
        <Title textColor="gray-600" fontWeight="normal" standardVariant="h4" desktopOnly={true} align="left">
          {descriptionText} {link}
        </Title>
        <div tw="lg:hidden block">
          <Paragraph standardVariant="body-sm" color="gray-600" align="left">
            {descriptionText} {link}
          </Paragraph>
        </div>
      </div>
    </FlexCol>
  );
};

export const FlexCol = tw.div`flex flex-col`;

export const TitleWrapper = tw.div`flex lg:flex-col flex-row lg:gap-4 gap-13.5 lg:items-start items-center`;
